/** DEMOKRATIFABRIK RUNTIME VARIABLES */
import { ref } from 'vue';
const assemblyIdentifier = ref(null);
const stageID = ref(null);
const setAssemblyIdentifier = (identifier) => {
    // console.log('SEET ASSEMBLY IDENTIFIER...', identifier);
    assemblyIdentifier.value = identifier;
};
const setStageID = (id) => (stageID.value = id);
export default function useStoreService() {
    return {
        assemblyIdentifier,
        setAssemblyIdentifier,
        setStageID,
        stageID,
    };
}
